(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sn-skin-type-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sn-skin-selector')) {
    customElements.define('sn-skin-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.button = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        this.label = this.querySelector('[data-button-label]');
        this.idleLabel = this.label.textContent;
        this.locked = false;
        this.querySelector('.sn-guide-tabs').setAttribute('role', 'tablist');
        this.tabs.forEach(tab => {
          tab.setAttribute('role', 'tab');
          tab.addEventListener('click', () => this.activate(tab.dataset.tab), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = this.tabs.indexOf(tab);
            if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else next = (next + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.activate(this.tabs[next].dataset.tab);
            this.tabs[next].focus();
          }, options);
        });
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.tab === panel.dataset.panel).id);
        });
        this.querySelectorAll('[data-choice]').forEach(choice => { choice.disabled = false; });
        this.addEventListener('change', event => this.onChange(event), options);
        this.button.addEventListener('click', () => this.addSelected(), options);
        document.addEventListener('shopify:block:select', event => {
          const card = [...this.querySelectorAll('[data-card]')].find(node => node.dataset.blockId === event.detail.blockId);
          if (card) this.activate(card.closest('[data-panel]').dataset.panel);
        }, options);
        this.setAttribute('data-enhanced', '');
        this.querySelector('.sn-guide-tabs').hidden = false;
        this.querySelector('[data-actions]').hidden = false;
        this.activate(this.tabs[0].dataset.tab);
        this.updateCount();
      }
      disconnectedCallback() { this.controller?.abort(); }
      activate(group) {
        this.tabs.forEach(tab => {
          const active = tab.dataset.tab === group;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== group; });
      }
      onChange(event) {
        const card = event.target.closest('[data-card]');
        if (!card) return;
        const variant = card.querySelector('[data-variant]');
        const choice = card.querySelector('[data-choice]');
        if (!variant || !choice) return;
        if (event.target.matches('[data-choice]') && choice.checked && !variant.value) {
          choice.checked = false;
          this.status.textContent = this.dataset.choose;
          variant.setAttribute('aria-invalid', 'true');
          variant.focus();
        } else if (event.target.matches('[data-variant]')) {
          variant.removeAttribute('aria-invalid');
          if (!variant.value) choice.checked = false;
          const option = variant.selectedOptions?.[0];
          const price = card.querySelector('[data-price]');
          price.textContent = option?.dataset.price || price.dataset.initialPrice;
          const link = card.querySelector('[data-product-link]');
          link.href = variant.value ? `${link.dataset.productUrl}?variant=${encodeURIComponent(variant.value)}` : link.dataset.productUrl;
          if (!this.locked) this.status.textContent = '';
        } else if (!this.locked) this.status.textContent = '';
        this.updateCount();
      }
      selectedItems() {
        const ids = new Set();
        this.querySelectorAll('[data-choice]:checked').forEach(choice => {
          const input = choice.closest('[data-card]').querySelector('[data-variant]');
          if (input?.value) ids.add(input.value);
        });
        return [...ids].map(id => ({ id: Number(id), quantity: 1 }));
      }
      updateCount() {
        const count = this.selectedItems().length;
        this.querySelector('[data-count]').textContent = `（${count}）`;
        this.button.disabled = this.locked || count === 0;
      }
      async addSelected() {
        if (this.locked) return;
        const items = this.selectedItems();
        if (!items.length) { this.status.textContent = this.dataset.empty; return; }
        this.locked = true;
        this.button.disabled = true;
        this.label.textContent = this.dataset.busy;
        this.status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-choice], [data-variant]').forEach(control => { control.disabled = true; });
        try {
          const response = await fetch(this.dataset.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.label.textContent = this.idleLabel;
          this.status.textContent = `${error.message || this.dataset.error} ${this.dataset.review}`;
          this.querySelector('[data-cart-review]').hidden = false;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
